import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  TextField,
  Grid,
  MenuItem,
  Typography,
  Checkbox,
  InputAdornment,
  Radio, RadioGroup, FormGroup, FormControlLabel, FormLabel, FormControl
} from '@material-ui/core';

import axios from 'axios';
import auth from '../../../../utils/auth';

const useStyles = makeStyles(() => ({
  root: {},
  item: {
    display: 'flex',
    flexDirection: 'column'
  }, 
  selectBox: {
    width: 'calc(100% - 8px)',
    marginBottom: '8px'
  },
	cardContentBox: {
		margin:'12px 0 4px 0'		
  },
	cardContentBoxHidden: {
		display:'none',
		margin:'12px 0 4px 0'		
  },
  spaceAround :{
		paddingBottom:'10px',
    justifyContent:'space-around'
  }
}));

const AddInfo = props => {
  const { extraInfo, strava } = props;
  const classes = useStyles();
	const userInfo = auth.getUserInfo();
	
	const [updateAvail, setUpdateAvail] = useState(Boolean(extraInfo.updateAvail));
	const [Rider, setRider] = useState({
		height: extraInfo.height,
	 	weight: extraInfo.weight,
		nation: extraInfo.nation,
	  gender: extraInfo.gender,
  	age: extraInfo.age,
		bikeType: [], 
		ridingYear: extraInfo.riding_year, 
  });

	const [BikeCheck, setBikeCheck] = React.useState({
    road: false,
    mtb: false,
    sharebike: false,
    minivelo: false,
		electric: false,
    hybrid: false,
	});

/*
	const [RidingCheck, setRidingCheck] = React.useState({
    commute: false,
    solo: false,
    group: false,
    indoor: false,
    job: false,
    hardly: false,
	});
*/
	const [RidingType, setRidingType] = React.useState('');
	const [PurposeCheck, setPurposeCheck] = React.useState({
		fitness: false,
		challenge: false,
		travel: false,
		compete: false,
		social: false,
	});

  
	const [activeStep, setActiveStep] = React.useState(-1);
	const [nextStep, setNextStep] = React.useState(true);
	const [backButtonText, setBackButtonText] = React.useState('뒤로');
	const [signOutDialog, setSignOutDialog] = React.useState(false);

	//핸들링 함수
	const handleNext = () => {
  	setActiveStep(prevActiveStep => prevActiveStep + 1);
		setNextStep(false);
	};

	const handleBack = () => {
		if(activeStep === -1) {
			setSignOutDialog(true);
		} else {
			setActiveStep(prevActiveStep => prevActiveStep - 1);
			setNextStep(true);
		};
	}

  const handleReset = () => {
   	setActiveStep(-1);
  };

 	const handleChangeRider = prop => event => {
		setRider({ ...Rider, [prop]: event.target.value });
	};

	const handleChangeRidingType = event => {
    	setRidingType(event.target.value);
	};

	const handleOpenSignOutDialog = () => {
		setSignOutDialog(true);
	};
	
	const handleCloseSignOutDialog = () => {
		setSignOutDialog(false);
	};

  //2개까지 체크
  const handleChangeBikeCheck = type => event => {
    let { road, mtb, sharebike, minivelo, electric, hybrid } = BikeCheck;
      let checked2 = [road, mtb, sharebike, minivelo, electric, hybrid].filter(v => v).length;

    if(checked2 < 2) { 
      setBikeCheck({ ...BikeCheck, [type]: event.target.checked });
    } else if(checked2 == 2 && event.target.checked === false) {
      setBikeCheck({ ...BikeCheck, [type]: event.target.checked });
    }
  };

  const handleChangePurposeCheck = type => event => {
    let { fitness, challenge, compete, travel, social } = PurposeCheck;
    let checked2 = [fitness, challenge, compete, travel, social].filter(v => v).length;

    if(checked2 < 2) { 
      setPurposeCheck({ ...PurposeCheck, [type]: event.target.checked });
    } else if(checked2 == 2 && event.target.checked === false) {
      setPurposeCheck({ ...PurposeCheck, [type]: event.target.checked });
      setNextStep(true);
    }
  };

  //Range menuitem 함수들
  const heightRange = () => {
    let range = [];
    for (var i=140; i <= 200; i++) {
      range.push(<MenuItem key={i} value={i}>{i}cm</MenuItem>);
    }
    return range;
  }

  const weightRange = (weight) => {
		let range = [];
		
    for (let i=weight-3; i <= weight+3; i++) {
      range.push(<MenuItem key={i} value={i}>{i}kg</MenuItem>);
    }
    return range;
  }

  const genderRange = () => {
    let range = [];
    range.push(<MenuItem key={0} value={"M"}>남자</MenuItem>);
    range.push(<MenuItem key={1} value={"F"}>여자</MenuItem>);
    return range;
  }

  const ageRange = () => {
    let range = [];
    range.push(<MenuItem key={0} value={19}>10대</MenuItem>);
    range.push(<MenuItem key={1} value={24}>20대초반</MenuItem>);
    range.push(<MenuItem key={2} value={29}>20대후반</MenuItem>);
    range.push(<MenuItem key={3} value={34}>30대초반</MenuItem>);
    range.push(<MenuItem key={4} value={39}>30대후반</MenuItem>);
    range.push(<MenuItem key={5} value={44}>40대초반</MenuItem>);
    range.push(<MenuItem key={6} value={49}>40대후반</MenuItem>);
    range.push(<MenuItem key={7} value={54}>50대초반</MenuItem>);
    range.push(<MenuItem key={8} value={59}>50대후반</MenuItem>);
    range.push(<MenuItem key={9} value={100}>60대이상</MenuItem>);
    return range;
  }

  const ridingYearRange = () => {
    let range = [];
    range.push(<MenuItem key={0} value={0}>1년미만</MenuItem>);
    range.push(<MenuItem key={1} value={1}>1년</MenuItem>);
    range.push(<MenuItem key={2} value={2}>2년</MenuItem>);
    range.push(<MenuItem key={3} value={3}>3년</MenuItem>);
    range.push(<MenuItem key={4} value={4}>4년</MenuItem>);
    range.push(<MenuItem key={5} value={5}>5년이상</MenuItem>);
    return range;
  }

  const bikeTypeRange = () => {
    let range = [];
    range.push(<MenuItem key={0} value={"road_allround"}>로드(올라운드)</MenuItem>);
    range.push(<MenuItem key={1} value={"road_aero"}>로드(에어로)</MenuItem>);
    range.push(<MenuItem key={2} value={"road_endurance"}>로드(엔듀런스)</MenuItem>);
    return range;
  }


	function updateAddInfo() {

		const auth_str = 'Bearer '.concat((auth.getToken().token)); 

		axios.post(
			`${process.env.REACT_APP_RESTAPI_BASE_URL}/json-api/set-extrainfo.php`, 
			{
				order : 'update_addinfo',
				new_weight : Rider.weight			
			}, 		
			{ 
				headers: { Authorization: auth_str }, 
			}
    ).then(response => {
      if(response.data.success) {
				let exInfo = auth.getExtraInfo();		
				exInfo.weight = Number(response.data.new_weight); 
				exInfo.updateAvail = false; 
				auth.setExtraInfo(exInfo, true);
				setUpdateAvail(false); 
			}
		}).catch((err) => {
			console.log(err);
		});
	}

	return (
    <Card className={clsx(classes.root, classes)}>
      <form autoComplete="off" noValidate>
        <CardContent className={classes.cardContent}>
          <Grid container spacing={1} className={classes.cardContentBox}>
            <Grid item md={3} xs={6}>
              <TextField className={classes.selectBox}
								variant="outlined"
								disabled
								select
								label="신장"
								value={Rider.height}
                onChange={handleChangeRider('height')}
                InputProps={{
                  classes: { input: classes.inputStyle },
                }}
							>
								{heightRange()}
							</TextField>
            </Grid>  
            <Grid item md={3} xs={6}>
							<TextField className={classes.selectBox}
								variant="outlined"
								select
								label="체중"
								value={Rider.weight}
								disabled={!updateAvail}
								onChange={handleChangeRider('weight')}
							>
								{weightRange(Number(extraInfo.weight))}
							</TextField>
            </Grid>  
            <Grid item md={3} xs={6}>
							<TextField className={classes.selectBox}
									variant="outlined"
									disabled
									select
									label="연령대"
									value={Rider.age}
									onChange={handleChangeRider('age')}
								>
								{ageRange()}
							</TextField>
            </Grid>  
            <Grid item md={3} xs={6}>
							<TextField className={classes.selectBox}
								variant="outlined"
								disabled
								select
								label="자전거경력"
								value={Rider.ridingYear}
								onChange={handleChangeRider('ridingYear')}
							>
								{ridingYearRange()}
							</TextField>
            </Grid>  
          </Grid>

          <Divider className={classes.divider} />

					<Box className={classes.cardContentBoxHidden}>
						<Typography gutterBottom variant="h6" component="h2">
							평소 즐겨 타는 자전거 종류는? (2개까지)
						</Typography>
						<FormGroup row className={classes.group}>
							<FormControlLabel 
								control={<Checkbox checked={BikeCheck.road} onChange={handleChangeBikeCheck('road')} value="road" />}
								label="로드자전거"
							/>
							<FormControlLabel
								control={<Checkbox checked={BikeCheck.mtb} onChange={handleChangeBikeCheck('mtb')} value="mtb" />}
								label="산악자전거"
							/>
							<FormControlLabel
								control={<Checkbox checked={BikeCheck.sharebike} onChange={handleChangeBikeCheck('sharebike')} value="sharebike" />}
								label="공유자전거"
							/>
							<FormControlLabel
								control={<Checkbox checked={BikeCheck.electric} onChange={handleChangeBikeCheck('electric')} value="electric" />}
								label="전기자전거"
							/>
							<FormControlLabel
								control={<Checkbox checked={BikeCheck.minivelo} onChange={handleChangeBikeCheck('minivelo')} value="minivelo" />}
								label="미니벨로"
							/>
							<FormControlLabel
								control={<Checkbox checked={BikeCheck.hybrid} onChange={handleChangeBikeCheck('hybrid')} value="hybrid" />}
								label="하이브리드"
							/>
							<FormControlLabel
								control={<Checkbox checked={BikeCheck.etc} onChange={handleChangeBikeCheck('etc')} value="etc" />}
								label="기타"
							/>
						</FormGroup>
					</Box>		

          <Divider className={classes.divider} />

					<Box className={classes.cardContentBoxHidden}>
						<Typography gutterBottom variant="h6" component="h2">
							평소에 즐겨하는 라이딩 유형은? 
						</Typography>
						<FormControl component="fieldset" className={classes.formControl}>
							<RadioGroup
								aria-label="BikeCheck"
								name="BikeCheck"
								className={classes.group}
								value={RidingType}
								onChange={handleChangeRidingType}
							>
						    <FormControlLabel value="commute" control={<Radio />} label="출퇴근 및 교통수단으로 이용" />
							  <FormControlLabel value="solo" control={<Radio />} label="혼자서 자유로운 라이딩을 하는 편" />
							 	<FormControlLabel value="group" control={<Radio />} label="동호회(팀)에서 그룹 라이딩을 즐김" />
							  <FormControlLabel value="indoor" control={<Radio />} label="실내에서 가상 라이딩을 주로 함" />
							  <FormControlLabel value="job" control={<Radio />} label="선수 및 트레이너 등 자전거 관련 직업" />
							  <FormControlLabel value="hardly" control={<Radio />} label="특별한 경우 외에 평소에는 타지 않음" />
							</RadioGroup>
						</FormControl>
					</Box>		

          <Divider className={classes.divider} />	

          <Box className={classes.cardContentBoxHidden}>
						<Typography gutterBottom variant="h6" component="h2">
							자전거를 열심히(잘) 타고 싶은 이유는? (2개까지) 
						</Typography>
						<FormGroup className={classes.group}>
							<FormControlLabel 
								control={<Checkbox checked={PurposeCheck.fitness} onChange={handleChangePurposeCheck('fitness')} value="fitness" />} 
								label="체중조절 및 건강한 신체유지" 
							/>
							<FormControlLabel
								control={<Checkbox checked={PurposeCheck.challenge} onChange={handleChangePurposeCheck('challenge')} value="challenge" />}
								label="국토종주/코스완주 등 도전과 성취감"
							/>
							<FormControlLabel
								control={<Checkbox checked={PurposeCheck.travel} onChange={handleChangePurposeCheck('travel')} value="travel" />}
								label="국내외를 어디든 자유롭게 여행"
							/>
							<FormControlLabel 
								control={<Checkbox checked={PurposeCheck.compete} onChange={handleChangePurposeCheck('compete')} value="compete" />} 
								label="MCT/힐클라임대회 등 경쟁대회 참가"
							/>
							<FormControlLabel
								control={<Checkbox checked={PurposeCheck.social} onChange={handleChangePurposeCheck('social')} value="social" />}
								label="스트레스해소/사람들과 어울리기 등"
							/>
						</FormGroup>
				  </Box>		
				</CardContent>
        <Divider />
        <CardActions className={classes.spaceAround}>			
					<Button 
						color="primary" variant="contained" onClick={updateAddInfo}
						disabled={!updateAvail}
					>
             정보저장
          </Button>
        </CardActions>
				{
					(!updateAvail && extraInfo.updateAvailDate) ? 
					<Typography component="div" variant="caption" align="center" style={{marginBottom:'8px'}}>
						{extraInfo.updateAvailDate} 이후에 수정가능합니다
					</Typography>
					: ""
				}
      </form>
    </Card>   
  );
};

AddInfo.propTypes = {
  className: PropTypes.string
};

export default AddInfo;
